module.exports = __webpack_public_path__ + "img/Copy_Filled.dad6611c.svg";